import { Validators } from "@angular/forms";
import { of } from "rxjs";
import { FieldEnum, IFormField, SubFieldEnum } from "../../shared/models/form-field";

export const ONLY_NUMBER_PATTERN = /^[0-9]\d*$/;
export const QES_DETAILS_FORMFIELDS: Array<IFormField> = [
    {
        fieldName: "division",
        displayName: "Division",
        defaultValue: null,
        labelName: "Division",
        placeholder: "Division",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled: true
    },
    {
        fieldName: "sales_or_service_order_no",
        displayName: "Sales/ Service Order Number",
        defaultValue: null,
        labelName: "Sales/ Service Order Number",
        placeholder: "Sales/ Service Order Number",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "BU",
        displayName: "BU",
        defaultValue: null,
        labelName: "BU",
        placeholder: "BU",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled: true
    },
    {
        fieldName: "sl_location",
        displayName: "SL Location",
        defaultValue: null,
        labelName: "SL Location",
        placeholder: "SL Location",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled: true
    },
    {
        fieldName: "delivery_location",
        displayName: "Delivery Location",
        defaultValue: null,
        labelName: "Delivery Location",
        placeholder: "Delivery Location",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled: true
    },
    {
        fieldName: "delivery_state",
        displayName: "Delivery State",
        defaultValue: null,
        labelName: "Delivery State",
        placeholder: "Delivery State",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled: true
    },
    {
        fieldName: "project_name",
        displayName: "Project Name",
        defaultValue: null,
        labelName: "Project Name",
        placeholder: "Project Name",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "project_status",
        displayName: "Project Status",
        defaultValue: null,
        labelName: "Project Status",
        placeholder: "Project Status",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "project_id",
        displayName: "Project ID",
        defaultValue: null,
        labelName: "Project ID",
        placeholder: "Project ID",
        validators: [Validators.pattern(/^([0-9]*)$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "procurement_type",
        displayName: "Procurement Type",
        defaultValue: null,
        labelName: "Procurement Type",
        placeholder: "Procurement Type",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "commodity",
        displayName: "Commodity",
        defaultValue: null,
        labelName: "Commodity",
        placeholder: "Commodity",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "rate_contract_exists",
        displayName: "Rate Contract Exists",
        defaultValue: null,
        labelName: "Rate Contract Exists",
        placeholder: "Rate Contract Exists",
        validators: null,
        fieldType: FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "rate_contract_exists",
            bindValue : "rate_contract_exists",
            dataFields : ['YES', 'NO']
        }
    },
    {
        fieldName: "LMU",
        displayName: "LMU",
        defaultValue: null,
        labelName: "LMU",
        placeholder: "LMU",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "esn_number",
        displayName: "ESN Number",
        defaultValue: null,
        labelName: "ESN Number",
        placeholder: "ESN Number",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true
    },
    {
        fieldName: "product_specification",
        displayName: "Product Specification",
        defaultValue: null,
        labelName: "Product Specification",
        placeholder: "Product Specification",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "quantity",
        displayName: "Quantity",
        defaultValue: null,
        labelName: "Quantity",
        placeholder: "Quantity",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "unit_of_measurement",
        displayName: "Unit Of Measurement",
        defaultValue: null,
        labelName: "Unit Of Measurement",
        placeholder: "Unit Of Measurement",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "other_esn_no",
        displayName: "Other ESN Number",
        defaultValue: null,
        labelName: "Other ESN Number",
        placeholder: "Other ESN Number",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "KAM_only_for_HC",
        displayName: "KAM (Only for Healthcare)",
        defaultValue: null,
        labelName: "KAM (Only for Healthcare)",
        placeholder: "KAM (Only for Healthcare)",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "other_project_requiring_same_item",
        displayName: "Other project requiring same item",
        defaultValue: null,
        labelName: "Other project requiring same item",
        placeholder: "Other project requiring same item",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-6",
        UIVisible: true
    },
    {
        fieldName: "project_commercial",
        displayName: "Project Commercial",
        defaultValue: null,
        labelName: "Project Commercial",
        placeholder: "Project Commercial",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "BU_SCMP",
        displayName: "BU SCMP",
        defaultValue: null,
        labelName: "BU SCMP",
        placeholder: "BU SCMP",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true
    },
    {
        fieldName: "group_technical",
        displayName: "Group Technical",
        defaultValue: null,
        labelName: "Group Technical",
        placeholder: "Group Technical",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "group_commercial",
        displayName: "Group Commercial",
        defaultValue: null,
        labelName: "Group Commercial",
        placeholder: "Group Commercial",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "SQM",
        displayName: "SQM",
        defaultValue: null,
        labelName: "SQM",
        placeholder: "SQM",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "vendor_specified_category",
        displayName: "Vendor Specified Category",
        defaultValue: null,
        labelName: "Vendor Specified Category",
        placeholder: "Vendor Specified Category",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "WBS_element",
        displayName: "WBS Element",
        defaultValue: null,
        labelName: "WBS Element",
        placeholder: "WBS Element",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "investment_order_or_other_ref",
        displayName: "Investment Order/ Other reference",
        defaultValue: null,
        labelName: "Investment Order/ Other reference",
        placeholder: "Investment Order/ Other reference",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "original_quoted_price_at_bidding_stage",
        displayName: "Originally quoted price at bidding stage",
        defaultValue: null,
        labelName: "Originally quoted price at bidding stage",
        placeholder: "Originally quoted price at bidding stage",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-6",
        UIVisible: true
    },
    {
        fieldName: "considered_cost_INR",
        displayName: "Considered cost(Order booking cost in SAP) INR",
        defaultValue: null,
        labelName: "Considered cost(Order booking cost in SAP) INR",
        placeholder: "Considered cost(Order booking cost in SAP) INR",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-6",
        UIVisible: true
    },
    {
        fieldName: "pip_considered", //verify field name
        displayName: "PIP Considered (%)",
        defaultValue: 0,
        labelName: "PIP Considered",
        placeholder: "PIP Considered",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "pip_achieved",
        displayName: "PIP Achieved (%)",
        defaultValue: 0,
        labelName: "PIP Achieved",
        placeholder: "PIP Achieved",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled: true
    },
    {
        fieldName: "ncc_cost",
        displayName: "NCC Cost",
        defaultValue: 0,
        labelName: "NCC Cost",
        placeholder: "NCC Cost",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: false
    },
    {
        fieldName: "net_savings_with_ncc",
        displayName: "Net of savings considering NCC",
        defaultValue: null,
        labelName: "Net of savings considering NCC",
        placeholder: "Net of savings considering NCC",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: false
    },
    {
        fieldName: "target_cost",
        displayName: "Target Cost",
        defaultValue: null,
        labelName: "Target Cost",
        placeholder: "Target Cost",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: false
    },
    {
        fieldName: "pip_with_ncc",
        displayName: "PIP considering NCC",
        defaultValue: null,
        labelName: "PIP considering NCC",
        placeholder: "PIP considering NCC",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: false
    },
    {
        fieldName: "ctm_measure",
        displayName: "CTM Measure",
        defaultValue: null,
        labelName: "CTM Measure",
        placeholder: "CTM Measure",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "month_of_negotiations",
        displayName: "Month of negotiations",
        defaultValue: null,
        labelName: "Month of negotiations",
        placeholder: "Month of negotiations",
        validators: null,
        fieldType: FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "month_of_negotiations",
            bindValue : "month_of_negotiations",
            dataFields : ['January', 'February', 'March', 'April', "May", "June", "July", "August", "September", "October", "November", "December"]
        }
    },
    {
        fieldName: "fin_year_of_negotiation",
        displayName: "Fin year of negotiations",
        defaultValue: null,
        labelName: "Fin year of negotiations",
        placeholder: "Fin year of negotiations",
        validators: [Validators.required],
        fieldType: FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "fin_year_of_negotiation",
            bindValue : "fin_year_of_negotiation",
            dataFields : []
        }
    },
    {
        fieldName: "pip_considered_based_on_IR_PVO",
        displayName: "PIP calculated based on IR PVO",
        defaultValue: null,
        labelName: "PIP calculated based on IR PVO",
        placeholder: "PIP calculated based on IR PVO",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: false
    },
    {
        fieldName: "negotiated_price",
        displayName: "Negotiated Total Price",
        defaultValue: null,
        labelName: "Negotiated Total Price",
        placeholder: "Negotiated Total Price",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: false,
        disabled: true
    },
]

export const QES_SINGLE_SPURCE_FORMFIELDS: Array<IFormField> = [
    {
        fieldName: "division",
        displayName: "Division",
        defaultValue: null,
        labelName: "Division",
        placeholder: "Division",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: false
    }
]
